import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
`

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
`
